import { catalogsReducers } from '../reducers'

export const catalogsRootReducers = {
  catalogs: catalogsReducers,
}
